import { render } from "./ModalFaleConosco.vue?vue&type=template&id=6e0e8d13&scoped=true"
import script from "./ModalFaleConosco.vue?vue&type=script&lang=js"
export * from "./ModalFaleConosco.vue?vue&type=script&lang=js"

import "./ModalFaleConosco.vue?vue&type=style&index=0&id=6e0e8d13&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0e8d13"]])

export default __exports__